/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_010: Question = {
  id: 'gov-010-biodiversite-zonage-urbanisme',
  oldId: '10',
  title: 'Prise en compte de la biodiversité dans le règlement de zonage et autres règlements d\'urbanisme et plan d\'urbanisme (PU).',
  number: '1.10',
  type: QuestionType.ACTIVITY,
  idEM: 1,
  frequency: 1,
  description: ['Prise en compte de la biodiversité dans le règlement de zonage et autres règlements d\'urbanisme et plan d\'urbanisme'],
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      scoringFct: (data: string[]) => parseFloat(data[0]),
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_gov_010_v2: Question = question_gov_010;
export const question_gov_010_v3: Question = question_gov_010;
